export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.tab = 'what-is-sms-service';
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/help/sms-services-help.controller.js